// import React from 'react'

// export const MyActionable = () => {
//   return (
//     <>
// <table class="table">
//             <thead>
//               <tr>
//                 <th scope="col">
//                   <p class="fs-14">S. #</p>
//                 </th>
//                 <th scope="col">
//                   <p class="fs-14">Date</p>
//                 </th>
//                 <th scope="col">
//                   <p class="fs-14">Reviewed Reason</p>
//                 </th>
//                 <th scope="col">
//                   <p class="fs-14">Status</p>
//                 </th>
//                 <th scope="col">
//                   <p class="fs-14">Remarks</p>
//                 </th>
//                 <th scope="col">
//                   <p class="fs-14">View</p>
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               <tr>
//                 <th scope="row">
//                   <p class="fs-14 fw-normal">1</p>
//                 </th>
//                 <td>
//                   <p class="fs-14 fw-normal">11 Jul 23</p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">Shivansh Dandona</p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">
//                     <button class="fs-14 fw-normal clrlightgreen border-0">
//                       Accepted
//                     </button>
//                   </p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">Partial Acceptance from Client</p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">
//                     <img src="/assets/images/Eye.svg" alt="" class="eye" />
//                   </p>
//                 </td>
//               </tr>
//               <tr>
//                 <th scope="row">
//                   <p class="fs-14 fw-normal">2</p>
//                 </th>
//                 <td>
//                   <p class="fs-14 fw-normal">11 Jul 23</p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">Shivansh Dandona</p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">
//                     <button class="fs-14 fw-normal back-clrred border-0">
//                       Discarded
//                     </button>
//                   </p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">Time Lapse</p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">
//                     <img src="/assets/images/Eye.svg" alt="" class="eye" />
//                   </p>
//                 </td>
//               </tr>
//               <tr>
//                 <th scope="row">
//                   <p class="fs-14 fw-normal">3</p>
//                 </th>
//                 <td>
//                   <p class="fs-14 fw-normal">11 Jul 23</p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">Shivansh Dandona</p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">
//                     <button class="fs-14 fw-normal clrlightgreen border-0">
//                       Accepted
//                     </button>
//                   </p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">Partially Executed</p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">
//                     <img src="/assets/images/Eye.svg" alt="" class="eye" />
//                   </p>
//                 </td>
//               </tr>
//               <tr>
//                 <th scope="row">
//                   <p class="fs-14 fw-normal">4</p>
//                 </th>
//                 <td>
//                   <p class="fs-14 fw-normal">11 Jul 23</p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">Shivansh Dandona</p>
//                 </td>
//                 <td colspan="2">
//                   <p class="fs-14 fw-normal">
//                     <button class="fs-14 fw-normal clrlightgreen border-0">
//                       Accepted
//                     </button>
//                   </p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">
//                     <img src="/assets/images/Eye.svg" alt="" class="eye" />
//                   </p>
//                 </td>
//               </tr>
//               <tr>
//                 <th scope="row">
//                   <p class="fs-14 fw-normal">5</p>
//                 </th>
//                 <td>
//                   <p class="fs-14 fw-normal">11 Jul 23</p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">Shivansh Dandona</p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">
//                     <button class="fs-14 fw-normal back-clrred border-0">
//                       Discarded
//                     </button>
//                   </p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">Declined by Client</p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">
//                     <img src="/assets/images/Eye.svg" alt="" class="eye" />
//                   </p>
//                 </td>
//               </tr>
//               <tr>
//                 <th scope="row">
//                   <p class="fs-14 fw-normal">6</p>
//                 </th>
//                 <td>
//                   <p class="fs-14 fw-normal">11 Jul 23</p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">Shivansh Dandona</p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">
//                     <button class="fs-14 fw-normal clrlightgreen border-0">
//                       Accepted
//                     </button>
//                   </p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">Time Lapse</p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">
//                     <img src="/assets/images/Eye.svg" alt="" class="eye" />
//                   </p>
//                 </td>
//               </tr>
//               <tr>
//                 <th scope="row">
//                   <p class="fs-14 fw-normal">7</p>
//                 </th>
//                 <td>
//                   <p class="fs-14 fw-normal">11 Jul 23</p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">Shivansh Dandona</p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">
//                     <button class="fs-14 fw-normal clrlightgreen border-0">
//                       Accepted
//                     </button>
//                   </p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">Partial Acceptance from Client</p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">
//                     <img src="/assets/images/Eye.svg" alt="" class="eye" />
//                   </p>
//                 </td>
//               </tr>
//               <tr>
//                 <th scope="row">
//                   <p class="fs-14 fw-normal">8</p>
//                 </th>
//                 <td>
//                   <p class="fs-14 fw-normal">11 Jul 23</p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">Shivansh Dandona</p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">
//                     <button class="fs-14 fw-normal clrlightgreen border-0">
//                       Accepted
//                     </button>
//                   </p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">Partial Acceptance from Client</p>
//                 </td>
//                 <td>
//                   <p class="fs-14 fw-normal">
//                     <img src="/assets/images/Eye.svg" alt="" class="eye" />
//                   </p>
//                 </td>
//               </tr>
//             </tbody>
//           </table>
//     </>
//   )
// }


import axios from 'axios'
import React from 'react'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'

export const MyActionable = ({ roomId, clientData }) => {
  const navigate = useNavigate()

  const handleKYCmodify = async () => {
    const allData = {
      client_id: roomId,
      panNo: clientData?.pan_no,
    }

    try {
      const response = await axios.post(
        `advisor/checkkycformodification`,
        allData
      )
      console.log('response',response);
      

      if (response.status === 200 && response.data?.kycstatus==="yes") {
        Swal.fire({
          title: 'KYC Verified!',
          text: 'Client KYC is ready for modification.',
          icon: 'success',
          customClass: {
            confirmButton: 'swal-confirm-btn',
          },
          confirmButtonText: 'Start Modification',
        }).then((result) => {
          if (result.isConfirmed) {
            navigate(`/what-we-will-need-from-you?clientId=${roomId}`)
          }
        })
      } else {
        Swal.fire({
          title: 'Failed!',
          text: response.data?.message || 'KYC modification not allowed.',
          icon: 'error',
        })
      }
    } catch (error) {
      Swal.fire({
        title: 'Error',
        text: error?.response?.data?.message || 'Something went wrong.',
        icon: 'error',
      })
    }
  }

  return (
    <div className="row pt-5 text-center bggrey">
      <div className="col-12">
        <button className="lrgbutton text-white" onClick={handleKYCmodify}>
          Modify KYC
        </button>
      </div>
    </div>
  )
}
